// react
import React from 'react';

// third-party
import { Helmet } from 'react-helmet';

// application
import PageHeader from '../shared/PageHeader';

// blocks
import BlockMap from '../blocks/BlockMap';

// data stubs
import theme from '../../data/theme';
import ContactForm from '../shared/ContactForm';


function SitePageContactUs() {
    const breadcrumb = [
        { title: 'Главная', url: '/' },
        { title: 'Наши контакты', url: '' },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Наши контакты — ${theme.name}`}</title>
            </Helmet>

            <BlockMap />

            <PageHeader header="Наши контакты" breadcrumb={breadcrumb} />

            <div className="block">
                <div className="container">
                    <div className="card mb-0">
                        <div className="card-body contact-us">
                            <div className="contact-us__container">
                                <div className="row">
                                    <div className="col-12 col-lg-6 pb-4 pb-lg-0">
                                        <h4 className="contact-us__header card-title">Контакты</h4>

                                        <div className="contact-us__address">
                                            <p>
                                                г. Новосибирск, советское шоссе 19/2
                                                <br />
                                                Email: info@tsttools.ru
                                                <br />
                                                Номер телефона: +7 (499) 322-22-56
                                            </p>

                                            <p>
                                                <strong>Часы работы</strong>
                                                <br />
                                                Понедельник - Пятница: 9:00 - 18:00
                                                <br />
                                                Суббота: Выходной
                                                <br />
                                                Воскресенье: Выходной
                                            </p>

                                            <p>

                                                <strong>О нас</strong>
                                                <br />
                                                Наша компания надежный и опытный поставщик
                                                металлообрабатывающего инструмента, технологической оснастки и
                                                комплектующих для станков с ЧПУ и не только.
                                                <br />

                                                Все наши работники являются высококвалифицированными специалистами, качественно
                                                оказывающими свои услуги и выполняющими пожелания заказчика.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-6">
                                        <h4 className="contact-us__header card-title">Оставьте заявку</h4>

                                        {/* <form>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="form-name">Your Name</label>
                                                    <input type="text" id="form-name" className="form-control" placeholder="Your Name" />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="form-email">Email</label>
                                                    <input
                                                        type="email"
                                                        id="form-email"
                                                        className="form-control"
                                                        placeholder="Email Address"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="form-subject">Subject</label>
                                                <input type="text" id="form-subject" className="form-control" placeholder="Subject" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="form-message">Message</label>
                                                <textarea id="form-message" className="form-control" rows="4" />
                                            </div>
                                            <button type="submit" className="btn btn-primary">Send Message</button>
                                        </form> */}
                                        <ContactForm/>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SitePageContactUs;
